module.exports = __webpack_public_path__ + "static/media/logo.b89f2d64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Page/svg/logo.svg
// module id = 182
// module chunks = 0